import React from "react";
import PropTypes from "prop-types";
import { connect } from "formik";
import Input from "./Toggle.js";
import formikShape from "../../shapes/formik.js";

const InputForm = ({ id, name = "agree", formik, label, ...props }) => {
  return (
    <Input
      id={id}
      name={name}
      errors={formik.errors}
      touched={formik.touched}
      label={label}
      value={formik.values[name]}
      includeValidity={true}
      handleChange={(e) => {
        formik.setFieldTouched(name, true);
        formik.setFieldValue(name, e.target.checked ? "on" : "off");
      }}
      {...props}
    />
  );
};

InputForm.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  value: PropTypes.string,
  label: PropTypes.string,
  formik: formikShape,
};
export default connect(({ formik, ...props }) => {
  return <InputForm formik={formik} {...props} />;
});
